export function print() {
    console.log('Gautam Memakiya')
}

export function erroranimate() {
    console.log('****** animation ******',erroranimate);
    var scene = document.getElementById('scene');
    var parallax = new Parallax(scene);
}